/* eslint-disable no-useless-concat */
import './searchInput.scss';
import {ReactComponent as Ic_Close} from 'resources/icons/Ic_close.svg';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ClipLoader } from 'react-spinners';
import { CSSProperties, useEffect, useState } from 'react';

export interface ISearchInput {
  value?: string | null;
  name?: string | undefined;
  placeholder: string;
  actionOnChange?: (...params: any)=>void;
  iconLeft?: any;
  iconRight?: any;
  style?:CSSProperties;
  id?:string
  disabled?:boolean
  type?:string;
  className?:string;
  onClear?:(...params)=>void
  onFocus?:(...params)=>void
  onBlur?:(...params)=>void
  loading?:boolean
}

export default function SearchInput(props:ISearchInput) {
  const {placeholder, actionOnChange, iconLeft, iconRight, style, value, onFocus, onBlur, loading} = props;
  const [foco, setFoco] = useState(false);
  const [inputValue, setValue] = useState(props.value || '');

  const onChange = (e) => {
   setValue(e.target.value);
   actionOnChange && actionOnChange(e.target.value);
  };

  const onClickDelete = () => {
    setValue('');
    setFoco(false);
    actionOnChange && actionOnChange('');
    props.onClear && props.onClear();
   };

   useEffect(()=>{
    //if(value){
      setValue(String(value ?? ''));
    //}
   },[value]);

  return (
    <div className={'searchInput' + (foco ? ' focused' : '') + (props.disabled ? ' --disabled' : '') + (props.className ? ' ' + props.className : '')} style={{...style}}>
      { iconLeft && <span className='searchInput_iconSearchContainer--left' onClick={()=>null}>
        <SvgIcon
          ariaLabel='icono-busqueda'
          Icon={iconLeft}
          className='searchInput_iconSearch'
        />
      </span> }
      <input type={props.type ? props.type : 'text'} placeholder={placeholder} name={props.name} aria-label={props.name} className='searchInput_input' onFocus={()=>{setFoco(true); onFocus && onFocus();}} onBlur={()=>{setFoco(false); onBlur && onBlur();}} value={inputValue} onChange={(e)=>onChange(e)} disabled={props.disabled}/>
      {inputValue !=='' && !props.disabled &&
        <div className='searchInput_iconDelSearchContainer' onClick={onClickDelete}>
          { loading
            ? <ClipLoader color={'#4C7C91'} speedMultiplier={0.7} size={30} />
            : <SvgIcon
            ariaLabel='icono-busqueda'
            Icon={inputValue !=='' ? Ic_Close : iconRight}
            className='searchInput_iconDelete'
            />
          }

        </div>
      }
      { inputValue ==='' && iconRight && <span className='searchInput_iconSearchContainer--left'>
        <SvgIcon
          ariaLabel='icono-busqueda'
          Icon={iconRight}
          className='searchInput_iconSearch'
          style={{cursor:'pointer'}}
        />
      </span> }
    </div>
 );
}
